import consts from "./consts";
import { User, UserSelf } from "@/types";
import { getPropertyByKeys } from "./utils";
import axios from "axios";
const COOKIE_NAME = "ORAI_AUTH";
const LOGIN_QUERY =
  "query User { me { doneJourneyOnboarding uid name email provider age language gender profession anon } }";

/**
 * Parse a jwt token
 * @param {JWT Token} token
 */
export function parseJwt(token: string) {
  let base64Url = token.split(".")[1];
  let base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(window.atob(base64));
}

function _getHostName(url: string) {
  let match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
  if (
    match != null &&
    match.length > 2 &&
    typeof match[2] === "string" &&
    match[2].length > 0
  ) {
    return match[2];
  } else {
    return null;
  }
}

export function getDomain(url: string) {
  let hostName = _getHostName(url);
  let domain = hostName;

  if (hostName != null) {
    let parts = hostName.split(".").reverse();

    if (parts != null && parts.length > 1) {
      domain = parts[1] + "." + parts[0];

      if (hostName.toLowerCase().indexOf(".co.uk") !== -1 && parts.length > 2) {
        domain = parts[2] + "." + domain;
      }
    }
  }

  return domain;
}

/**
 * Save JWT Token in the cookies for orai domain
 * @param {*jwtToken to store} jwtToken
 */
export function setCookie(jwtToken: string) {
  // console.log("SET COOKIE", jwtToken);
  let parsed = parseJwt(jwtToken);
  let myDate = new Date(parsed.exp * 1000);
  let domain = getDomain(window.location.href);
  (window as any).$cookies.set(COOKIE_NAME, jwtToken, myDate, "/", domain);
  console.log(
    COOKIE_NAME +
      "=" +
      jwtToken +
      ";expires=" +
      myDate +
      ";domain=" +
      "." +
      domain +
      ";path=/"
  );
}

/**
 * Read Query Parameters
 * @param {*Query Parameter to fetch} name
 * @param {* optional custom url} url
 */
export function getURLParam(name: string, url: string) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  let reg = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  let results = reg.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/**
 * Login With SSO Token
 * @param {* SSO Token} token
 * @param {* success callback function} onSuccess
 * @param {* error callback function} onError
 */
export function loginSocial(
  token: string,
  // tslint:disable-next-line: ban-types
  onSuccess: Function,
  // tslint:disable-next-line: ban-types
  onError: Function
) {
  axios({
    method: "POST",
    url: consts.serverURL + "login/social",
    headers: {
      "X-Orai-SignupMethod": "web",
    },
    data: {
      Provider: "saml",
      Code: token,
      query: LOGIN_QUERY,
    },
  })
    .then((resp) => {
      console.log("SSO", resp);
      //const user: User = resp && resp.data;
      const user: UserSelf = resp.data.data.me;
      let jwt = getPropertyByKeys(resp, ["headers", "authentication"]);
      if (jwt) {
        setCookie(jwt);
        if (onSuccess) {
          onSuccess(jwt, user);
        }
      }
    })
    .catch((reason) => {
      console.log(reason, reason.response);
      let errormsg = getPropertyByKeys(reason, ["response", "data", "error"]);
      if (onError) {
        onError(errormsg);
      }
    });
}

/**
 * Login With Email and Password
 * @param {* Email address} email
 * @param {* password string} password
 * @param {* success callback function} onSuccess
 * @param {* error callback function} onError
 */
export function loginEmail(
  email: string,
  password: string,
  // tslint:disable-next-line: ban-types
  onSuccess?: Function,
  // tslint:disable-next-line: ban-types
  onError?: Function
) {
  axios({
    method: "POST",
    url: consts.serverURL + "login/email",
    headers: {
      "X-Orai-SignupMethod": "web",
    },
    data: {
      Email: email,
      Password: password,
      query: LOGIN_QUERY,
    },
  })
    .then((resp) => {
      console.log("LOGIN EMAIL", resp);
      const user: UserSelf = resp.data.data.me;
      let jwt = getPropertyByKeys(resp, ["headers", "authentication"]);
      if (jwt) {
        setCookie(jwt);
        if (onSuccess) {
          onSuccess(jwt, user);
        }
      }
    })
    .catch((reason) => {
      console.log(reason, reason.response);
      let errormsg = getPropertyByKeys(reason, ["response", "data", "Error"]);
      if (onError) {
        onError(errormsg);
      }
    });
}

/**
 * Reset Password With Email
 * @param {* Email address} email
 * @param {* success callback function} onSuccess
 * @param {* error callback function} onError
 */
export function resetPassword(
  email: string,
  onSuccess?: Function,
  onError?: Function
) {
  axios({
    method: "POST",
    url: consts.serverURL + "login/request-reset-password",
    data: {
      Email: email,
    },
  })
    .then((resp) => {
      let description = getPropertyByKeys(resp, ["data", "Description"]);

      if (description && onSuccess) {
        onSuccess(description);
      }
    })
    .catch((reason) => {
      console.log(reason, reason.response);
      let errormsg = getPropertyByKeys(reason, ["response", "data", "Error"]);
      if (onError) {
        onError(errormsg);
      }
    });
}

/**
 * Login With Email and Password
 * @param {* Email address} email
 * @param {* password string} password
 * @param {* success callback function} onSuccess
 * @param {* error callback function} onError
 */
export function signupEmail(
  email: string,
  password: string,
  name: string,
  affiliateCode?: string,

  // tslint:disable-next-line: ban-types
  onSuccess?: Function,
  // tslint:disable-next-line: ban-types
  onError?: Function
) {
  axios({
    method: "POST",
    url: consts.serverURL + "signup/email",
    headers: {
      "X-Orai-SignupMethod": "web",
    },
    data: {
      Name: name,
      Email: email,
      Password: password,
      AffiliateCode: affiliateCode,
      query: LOGIN_QUERY,
    },
  })
    .then((resp) => {
      console.log("Signup EMAIL", resp);
      //const user: User = resp && resp.data;
      const user: UserSelf = resp.data.data.me;
      let jwt = getPropertyByKeys(resp, ["headers", "authentication"]);
      if (jwt) {
        setCookie(jwt);
        if (onSuccess) {
          onSuccess(jwt, user);
        }
      }
    })
    .catch((reason) => {
      console.log(reason, reason.response);
      let errormsg = getPropertyByKeys(reason, ["response", "data", "Error"]);
      if (onError) {
        onError(errormsg);
      }
    });
}

/**
 * Logout
 */
export function logout() {
  (window as any).$cookies.remove(COOKIE_NAME);
  (window as any).$cookies.remove(consts.currentLearnerTeam);
}
